import { useEffect, useId, useRef, type ReactNode } from 'react';

/** Diálogo modal acessível (foco inicial, Esc, foco preso no diálogo). Extraído da SWOT (IM-EXT-010) para reúso (IM-EXT-011). */
export function Modal({ title, onClose, children, wide = false, role = 'dialog' }: { title: string; onClose: () => void; children: ReactNode; wide?: boolean; role?: 'dialog' | 'alertdialog' }) {
  const id = useId();
  const box = useRef<HTMLDivElement>(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const el = box.current;
    (el?.querySelector<HTMLElement>('[data-autofocus]') ?? el?.querySelector<HTMLElement>('input, select, textarea, button'))?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.stopPropagation(); closeRef.current(); }
      if (e.key === 'Tab' && el) {
        const f = [...el.querySelectorAll<HTMLElement>('a[href], button:not([disabled]), input, select, textarea, [tabindex="0"]')];
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1)!.focus(); }
        else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0]!.focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);
  return (
    <div className="dialog-backdrop" role="presentation" onClick={onClose}>
      <div ref={box} className={`dialog card${wide ? ' wide' : ''}`} role={role} aria-modal="true" aria-labelledby={id} onClick={(e) => e.stopPropagation()}>
        <h2 id={id}>{title}</h2>
        {children}
      </div>
    </div>
  );
}
